import React, { forwardRef, memo } from 'react';
import { Layout, StyledLink } from './NavigationTabLink.styles';
import { jsx as _jsx } from "react/jsx-runtime";
const NavigationTabLinkComponent = /*#__PURE__*/forwardRef(({
  link
}, ref) => /*#__PURE__*/_jsx(Layout, {
  ref: ref,
  children: /*#__PURE__*/_jsx(StyledLink, {
    isActive: link.isActive,
    to: link.path,
    children: link.title
  })
}));
export const NavigationTabLink = /*#__PURE__*/memo(NavigationTabLinkComponent);